import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BaseIconButton from "@material-ui/core/IconButton";

const sizes = {
  small: 0.5,
  medium: 0.8,
  large: 1,
};

const paddings = {
  small: 0.25,
  medium: 0.6,
  large: 1.25,
};

const useStyles = makeStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: ({ size = "medium" }) => sizes[size] * 14,
    padding: ({ size = "medium" }) => paddings[size] * 12,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.10)",
    },
  },
});

const StyledIconButton = (props) => {
  const classes = useStyles(props);

  return <BaseIconButton {...props} classes={classes} />;
};

export default StyledIconButton;
